import { bindRequestLogic } from './utils'
import Types from '../actionTypes/kitUpdatePers'
import { kitUpdatePersAPI } from '../api'

export const getListKitUpdatePers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.getListKitUpdatePers,
  type: Types.GET_LIST_KIT_UPDATE_PERS_REQUEST,
  successType: Types.GET_LIST_KIT_UPDATE_PERS_SUCCESS,
  failType: Types.GET_LIST_KIT_UPDATE_PERS_FAILED,
  isQueryParam: true
})

export const getDetailKitUpdatePers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.getDetailKitUpdatePers,
  type: Types.GET_DETAIL_KIT_UPDATE_PERS_REQUEST,
  successType: Types.GET_DETAIL_KIT_UPDATE_PERS_SUCCESS,
  failType: Types.GET_DETAIL_KIT_UPDATE_PERS_FAILED
})

export const deleteKitUpdatePers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.deleteKitUpdatePers,
  type: Types.DELETE_KIT_UPDATE_PERS_REQUEST,
  successType: Types.DELETE_KIT_UPDATE_PERS_SUCCESS,
  failType: Types.DELETE_KIT_UPDATE_PERS_FAILED
})

export const addKitUpdatePers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.addKitUpdatePers,
  type: Types.ADD_KIT_UPDATE_PERS_REQUEST,
  successType: Types.ADD_KIT_UPDATE_PERS_SUCCESS,
  failType: Types.ADD_KIT_UPDATE_PERS_FAILED
})

export const updateKitUpdatePers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.updateKitUpdatePers,
  type: Types.UPDATE_KIT_UPDATE_PERS_REQUEST,
  successType: Types.UPDATE_KIT_UPDATE_PERS_SUCCESS,
  failType: Types.UPDATE_KIT_UPDATE_PERS_FAILED
})

export const transitionKitUpdatePers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.transitionKitUpdatePers,
  type: Types.TRANSITION_KIT_UPDATE_PERS_REQUEST,
  successType: Types.TRANSITION_KIT_UPDATE_PERS_SUCCESS,
  failType: Types.TRANSITION_KIT_UPDATE_PERS_FAILED
})

export const attachKitUpdatePersTargets = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.attachKitUpdatePersTargets,
  type: Types.ATTACH_KIT_UPDATE_PERS_TARGETS_REQUEST,
  successType: Types.ATTACH_KIT_UPDATE_PERS_TARGETS_SUCCESS,
  failType: Types.ATTACH_KIT_UPDATE_PERS_TARGETS_FAILED
})

export const detachKitUpdatePersTarget = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.detachKitUpdatePersTarget,
  type: Types.DETACH_KIT_UPDATE_PERS_TARGET_REQUEST,
  successType: Types.DETACH_KIT_UPDATE_PERS_TARGET_SUCCESS,
  failType: Types.DETACH_KIT_UPDATE_PERS_TARGET_FAILED
})

export const bulkDetachKitUpdatePersTargets = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.bulkDetachKitUpdatePersTargets,
  type: Types.BULK_DETACH_KIT_UPDATE_PERS_TARGETS_REQUEST,
  successType: Types.BULK_DETACH_KIT_UPDATE_PERS_TARGETS_SUCCESS,
  failType: Types.BULK_DETACH_KIT_UPDATE_PERS_TARGETS_FAILED
})

export const searchKitUpdatePersPickerPers = bindRequestLogic({
  clientFunc: kitUpdatePersAPI.searchKitUpdatePersPickerPers,
  type: Types.SEARCH_KIT_UPDATE_PERS_PICKER_PERS_REQUEST,
  successType: Types.SEARCH_KIT_UPDATE_PERS_PICKER_PERS_SUCCESS,
  failType: Types.SEARCH_KIT_UPDATE_PERS_PICKER_PERS_FAILED,
  isQueryParam: true
})

export default [
  getListKitUpdatePers,
  getDetailKitUpdatePers,
  deleteKitUpdatePers,
  addKitUpdatePers,
  updateKitUpdatePers,
  transitionKitUpdatePers,
  attachKitUpdatePersTargets,
  detachKitUpdatePersTarget,
  bulkDetachKitUpdatePersTargets,
  searchKitUpdatePersPickerPers
]
